angular.module('zc.core')
  .factory('barChartV2Config', barChartV2Config);

barChartV2Config.$inject = ['baseChartV2Config'];
function barChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'bar' },
    },
    xAxis: {
      title: { text: null },
      type: 'category',
    },
    yAxis: {
      title: { text: null },
      min: 0,
    },
  }, baseChartV2Config);
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/bar_chart_v2_config.service.js